import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

let config = process.env.ROUTER
let routes = Array.prototype.concat(
  require('./routes.guests').default,
  require('./routes.users').default,
  require('./routes.admin').default
)

export default new Router({
  mode: config.mode,
  routes: routes
})



//////////////////
// WEBPACK FOOTER
// ./src/router/index.js
// module id = 317
// module chunks = 1